import React from 'react'
import { Section, Container, Header, Text } from './styles'
import { GUARANTEE_CONSTANTS } from '../Guarantee/constants'

const FreeReturns = () => (
  <Section>
    <Container>
      <Header>{GUARANTEE_CONSTANTS.returns}</Header>
      <Text>
        Your happiness is our happiness. If you aren't 100% thrilled with your purchase, return it
        for a full refund. No questions asked.
      </Text>
    </Container>
  </Section>
)

export default FreeReturns
